import { useMemo } from "react";
import { useGetAdminDashboardStatsQuery } from "../../../services/api";
import "./AdminAnalytics.css";

// KPI Icons
const KpiIcon = ({ type }) => {
  switch (type) {
    case "users":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1366)">
            <path
              d="M3.33325 4.66667C3.33325 5.37391 3.6142 6.05219 4.1143 6.55229C4.6144 7.05238 5.29267 7.33333 5.99992 7.33333C6.70716 7.33333 7.38544 7.05238 7.88554 6.55229C8.38563 6.05219 8.66659 5.37391 8.66659 4.66667C8.66659 3.95942 8.38563 3.28115 7.88554 2.78105C7.38544 2.28095 6.70716 2 5.99992 2C5.29267 2 4.6144 2.28095 4.1143 2.78105C3.6142 3.28115 3.33325 3.95942 3.33325 4.66667Z"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 14V12.6667C2 11.9594 2.28095 11.2811 2.78105 10.781C3.28115 10.281 3.95942 10 4.66667 10H7.33333C8.04058 10 8.71885 10.281 9.21895 10.781C9.71905 11.2811 10 11.9594 10 12.6667V14"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.6667 2.08667C11.2404 2.23354 11.7488 2.56714 12.1118 3.03488C12.4749 3.50262 12.672 4.07789 12.672 4.67C12.672 5.26212 12.4749 5.83739 12.1118 6.30513C11.7488 6.77287 11.2404 7.10647 10.6667 7.25334"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 14.0001V12.6668C13.9966 12.0782 13.7986 11.5073 13.4368 11.043C13.0751 10.5788 12.5699 10.2472 12 10.1001"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1366">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "chart":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1406)">
            <path
              d="M5.70668 2.45996C4.97873 2.76129 4.31726 3.20302 3.76001 3.75996"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.46 5.70679C2.1577 6.43365 2.0014 7.2129 2 8.00012"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.45996 10.2932C2.76129 11.0212 3.20302 11.6826 3.75996 12.2399"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.70679 13.54C6.43365 13.8423 7.2129 13.9986 8.00012 14"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.2932 13.54C11.0212 13.2387 11.6826 12.7969 12.2399 12.24"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.54 10.2933C13.8423 9.56647 13.9986 8.78722 14 8"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.54 5.70668C13.2387 4.97873 12.7969 4.31726 12.24 3.76001"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.2933 2.46C9.56647 2.1577 8.78722 2.0014 8 2"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1406">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "trending":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1444)">
            <path
              d="M3.33325 8.00008L6.66659 11.3334L13.3333 4.66675"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1444">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "calendar":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1453)">
            <path
              d="M2 11.3334L6 7.33341L8.66667 10.0001L14 4.66675"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.33325 4.66675H13.9999V9.33341"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1453">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    default:
      return null;
  }
};

export default function AdminAnalytics() {
  const { data, isLoading } = useGetAdminDashboardStatsQuery();

  const kpis = data?.kpis || {};

  const kpiCards = [
    { label: "Total Users", value: kpis.totalUsers ?? "...", icon: "users" },
    { label: "Total Companies", value: kpis.totalCompanies ?? "...", icon: "chart" },
    { label: "Learning Resources", value: kpis.totalLearningResources ?? "...", icon: "trending" },
    { label: "Active Users", value: kpis.activeUsers ?? "...", icon: "calendar" },
  ];

  /* ---------- Chart data from API ---------- */
  const monthly = useMemo(() => {
    if (!data?.monthlyTrends?.length) return [];
    return data.monthlyTrends.map((t) => ({
      m: t.month,
      v: t.diagnostics + t.surveys,
    }));
  }, [data?.monthlyTrends]);

  const byCompany = useMemo(() => {
    if (!data?.statsByCompany?.length) return [];
    return data.statsByCompany.slice(0, 5).map((c) => ({
      t: c.companyName?.length > 10 ? c.companyName.slice(0, 10) + "…" : c.companyName,
      v: c.memberCount,
    }));
  }, [data?.statsByCompany]);

  return (
    <div className="analytics">
      {/* KPI cards */}
      <div className="analytics-kpis">
        {kpiCards.map((k) => (
          <div className="main-card" key={k.label}>
            <div className="maincard-head">
              <span className="summary-icon">
                <KpiIcon type={k.icon} />
              </span>
              <span className="maincard-title">{k.label}</span>
            </div>
            <div className="maincard-value">
              {isLoading ? "..." : k.value}
            </div>
          </div>
        ))}
      </div>

      {/* Charts */}
      <div className="analytics-charts">
        <div className="analytics-card">
          <div className="analytics-card-head">Monthly Activity</div>
          <BarChart data={monthly} />
        </div>

        <div className="analytics-card">
          <div className="analytics-card-head">By Company</div>
          <BarChart data={byCompany} showLabelsKey="t" />
        </div>
      </div>
    </div>
  );
}

/* --------- A tiny CSS-only bar chart component --------- */
function BarChart({ data, showLabelsKey }) {
  if (!data || data.length === 0) {
    return (
      <div className="bar-chart" style={{ textAlign: "center", padding: "2rem", color: "#999" }}>
        No data available
      </div>
    );
  }

  const max = Math.max(...data.map((d) => d.v), 1);
  const niceMax = Math.ceil(max / 5) * 5 || 5;
  const yTicks = [niceMax, Math.round(niceMax * 0.75), Math.round(niceMax * 0.5), Math.round(niceMax * 0.25), 0];

  return (
    <div className="bar-chart">
      <div className="chart-y-axis">
        {yTicks.map((t, i) => (
          <span key={i}>{t}</span>
        ))}
      </div>
      <div className="bars">
        {data.map((d, i) => {
          const h = (d.v / niceMax) * 100;
          const isMax = d.v === max && max > 0;
          return (
            <div className="bar-wrap" key={i} title={`${d.v}`}>
              <div
                className={`bar ${isMax ? "is-highlight" : ""}`}
                style={{ height: `${Math.min(h, 100)}%` }}
              >
                <span className="bar-label">{d.v}</span>
              </div>
              <div className="bar-x">
                {showLabelsKey ? d[showLabelsKey] : d.m}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
